import { makeStyles, Paper, Typography } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css"; // eslint-disable-line import/no-extraneous-dependencies
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getSponsors } from "../ducks/actions";
import * as types from "../ducks/types";
import { useCongressStyle } from "../hooks";
import Loader from "./Loader";
import NoData from "./NoData";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  sponsorListWrap: {},
  sponsorList: {
    "& > .splide > .splide__slider": {
      paddingBottom: "2rem"
    },
    "& > .splide > .splide__pagination": {
      " & > li > .is-active": {
        backgroundColor: theme.palette.primary.main
      }
    }
  },
  sponsorContainer: {
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(1),
    cursor: "pointer",
    background: "white",
    height: theme.spacing(9),
    overflow: "hidden",
    textAlign: "center"
  },
  sponsorLogo: {
    height: "100%"
  },
  sponsorName: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    height: "100%",
    maxWidth: 600,
    lineHeight: "2.4rem",
    fontWeight: "bold",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
}));

const SponsorList = () => {
  const intl = useIntl();
  const classes = useStyles();
  const congressClasses = useCongressStyle()();
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(getSponsors());
  }, [dispatch]);
  const {
    data: { data: sponsors },
    loading
  } = useQuery({ type: types.GET_SPONSORS, defaultData: { data: [] } });

  const onSponsorClick = ({ id }) => () => {
    history.push(`/companies/${id}`);
  };
  return (
    <Paper elevation={0} className={`${classes.root} ${congressClasses.congress}`}>
      <Typography variant="body2" gutterBottom>
        {intl.formatMessage({
          id: "Shared.SponsorList.SponsoredBy",
          defaultMessage: "Sponsored by"
        })}
        :
      </Typography>
      <div className={classes.sponsorListWrap}>
        <div className={classes.sponsorList}>
          <Loader loading={loading}>
            <NoData
              message={intl.formatMessage({
                id: "Shared.SponsorList.NoSponsorData",
                defaultMessage: "There are no sponsors. Please check later for new contents..."
              })}
              data={sponsors}
            >
              <Splide
                options={{
                  type: "loop",
                  // rewind: true,
                  autoWidth: true,
                  // perPage: 4,
                  trimSpace: "move",
                  focus: "center",
                  // gap: "0.3rem",
                  autoplay: true,
                  arrows: false,
                  interval: 3000,
                  pagination: false,
                  breakpoints: {
                    600: {
                      perPage: 1,
                      autoWidth: false
                      // focus: "center"
                      // trimSpace: false
                    }
                  }
                }}
                hasSliderWrapper
              >
                {sponsors.map(({ id, name, logo }) => (
                  <SplideSlide key={id}>
                    <div className={classes.sponsorContainer} onClick={onSponsorClick({ id })}>
                      {logo ? (
                        <img alt={name} src={logo} className={classes.sponsorLogo} />
                      ) : (
                        <Typography variant="h6" gutterBottom className={classes.sponsorName}>
                          {name}
                        </Typography>
                      )}
                    </div>
                  </SplideSlide>
                ))}
              </Splide>
            </NoData>
          </Loader>
        </div>
      </div>
    </Paper>
  );
};

export default SponsorList;
